import { S145gS145m01Component } from './s145g-s145m01.component';
import { S145gS145m02Component } from './s145g-s145m02.component';

export { S145gModule } from './s145g.module';

export const S145gSubComponentsMap = {
	
};

export const S145gComponentsMap = {
	"s145g-s145m01": S145gS145m01Component,
	"s145g-s145m02": S145gS145m02Component
};

export const S145gComponents = [
	S145gS145m01Component,
	S145gS145m02Component
];

